import { render, staticRenderFns } from "./DataIntegrator.vue?vue&type=template&id=41d21066"
import script from "./DataIntegrator.vue?vue&type=script&lang=js"
export * from "./DataIntegrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports